import { defineStore } from 'pinia'

export const useModalStore = defineStore({
    id: 'modal',
    state: () => ({
        imageConfirmationModal: {
            show: false,
            itemForDelete: null,
            itemIdForDelete: null
        },
        entityModal: {
            show: false,
            entityType: null,
            entityId: null
        },
        addParcelModal: {
            show: false,
            mode: 'create',
            initialData: null,
            entityId: null
        },
        addPassengerModal: {
            show: false,
            mode: 'create',
            initialData: null,
            entityId: null
        },
        activeRoutePointModal: {
            show: false,
            pointData: null,
            lastCompleted: false,
            firstUncompleted: false
        },
        commentModal: {
            show: false,
            text: null,
            // view | create | edit
            mode: 'view',
            commentId: null,
            entityId: null,
            entityType: null,
            can_edit: false,
            onCreated: null,
            onEdited: null,
            onDeleted: null
        }
    }),
    actions: {}
})
